import dayjs from 'dayjs';
import React from 'react';
import { ApplicationRoundFeedbackHistoryDocument } from 'types';

interface Props {
	roundFeedbackHistory?: ApplicationRoundFeedbackHistoryDocument[];
}

const RecruiterRoundFeedback = ({ roundFeedbackHistory }: Props) => {
	if (!roundFeedbackHistory) return null;
	return (
		<div className="bg-[#F7F9FB] flex flex-col gap-[27px] mt-4">
			{roundFeedbackHistory
				?.filter(el => el?.message)
				?.map((feedback, index) => (
					<div key={index} className="pb-[10px] border-b border-[#E4E4EB]">
						<div className="flex items-center justify-between flex-wrap">
							<div className="text-base font-[600] text-[#1C1C28]">Round {feedback?.order}</div>
							<div className="text-xs font-[400] text-[#8F90A6]">
								{dayjs(feedback?.createdAt || '').format('DD MMM, YYYY [at] HH:mm')}
							</div>
						</div>

						<div className="mt-[8px] text-[#585757] text-sm font-[400]">{feedback?.message}</div>
					</div>
				))}
		</div>
	);
};

export default RecruiterRoundFeedback;
